export default function Loading() {
	return (
		<div className="block size-full h-screen bg-purple-900 p-1">
			<p className="text-purple-50">loading</p>
			<p className="text-violet-50">
				imagine there's like a spinner here and branding and stuff
			</p>
		</div>
	)
}
